import { FC } from 'react';
import SectionLayout from 'atoms/components/SectionLayout';
import PowerBiGraph from '../PowerBiGraph';
import './ScoreMap.scss';
import { useTranslation } from 'react-i18next';

const ScoreMap: FC = () => {
  const { t } = useTranslation();

  return (
    <SectionLayout
      className="score-map"
      header={<span className="title">{t('Score map')}</span>}
    >
      <PowerBiGraph />
    </SectionLayout>
  );
};

export default ScoreMap;
